import { render, staticRenderFns } from "./AdaptedPhysicalActivitiesComp.vue?vue&type=template&id=76dfb014&scoped=true"
import script from "./AdaptedPhysicalActivitiesComp.vue?vue&type=script&lang=js"
export * from "./AdaptedPhysicalActivitiesComp.vue?vue&type=script&lang=js"
import style0 from "./AdaptedPhysicalActivitiesComp.vue?vue&type=style&index=0&id=76dfb014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dfb014",
  null
  
)

/* custom blocks */
import block0 from "./AdaptedPhysicalActivitiesComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports